<template>
  <div class="store-list content-container">
    <div class="store-page-header breakout">
      <div class="content-container">
        <span>{{ "store_list.header.span" | translate }}</span>
        <h1 class="text-gradient purple">
          {{ "store_list.header.h1" | translate }}
        </h1>
        <p>{{ "store_list.header.p" | translate }}</p>
      </div>
    </div>
    <div class="tag-filter-container">
      <h4>{{ "store_list.filter.title" | translate }}</h4>
      <div class="tags">
        <div class="tag-container" @click="tagSelected()">
          <div class="tag-icon"></div>
          <span
            class="tag"
            :class="{
              selected: selectedTag === null || selectedTag === undefined
            }"
          >
            {{ "store_list.filter.all" | translate }}
          </span>
        </div>
        <div
          v-for="(tag, i) in tags"
          :key="i"
          class="tag-container"
          @click="tagSelected(tag)"
        >
          <div class="tag-icon"></div>
          <span class="tag" :class="{ selected: tag === selectedTag }">{{
            tag
          }}</span>
        </div>
      </div>
    </div>
    <div v-if="hasStores" class="store-grid">
      <store-card
        v-for="(store, j) in filteredStores"
        :key="j"
        :name="store.storeName"
        @click.native="onStoreClicked(store.storeName)"
      >
      </store-card>
    </div>
  </div>
</template>

<script>
import storeCard from "../components/molecules/store-card.vue";
import { getStores } from "../services/api";
import { mapMutations } from "vuex";

export default {
  components: { storeCard },
  name: "store-list",
  data() {
    return {
      stores: null,
      tags: Array,
      selectedTag: null
    };
  },
  methods: {
    async getStores() {
      const response = await getStores();
      this.stores = response.data;

      var i;
      var store_tags = [];
      for (i = 0; i < this.stores.length; i++) {
        store_tags.push(this.stores[i].tags);
        this.tags = [...new Set(store_tags.flat())];
      }
    },
    onStoreClicked(store) {
      this.resetFilters();
      this.$router.push({
        name: "StorePage",
        params: {
          store: store
        }
      });
    },
    tagSelected(tag) {
      this.selectedTag = tag;
    },
    ...mapMutations({
      resetFilters: "filters/reset"
    })
  },
  computed: {
    hasStores() {
      return this.stores && this.stores.length > 0;
    },
    hasTags() {
      return this.tags && this.tags.length > 0;
    },
    filteredStores() {
      if (this.selectedTag == null) {
        return this.stores;
      }
      return this.stores.filter(store => {
        return store.tags.includes(this.selectedTag);
      });
    }
  },
  mounted() {
    this.getStores();
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";

.store-page-header {
  text-align: center;
  background-color: $brand-gray-light;
  padding-top: 5rem;
  padding-bottom: 5rem;

  .content-container {
    margin: auto;

    span {
      display: block;
    }

    h1 {
      font-size: 4.5rem;
    }

    span,
    h1 {
      margin-bottom: 2rem;
      white-space: pre-wrap;
    }
  }
}

.tag-filter-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 0;

  h4 {
    margin-bottom: 2rem;
  }
}

.tags {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;

  .tag-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 0.5rem;
    margin-bottom: 1rem;
    min-width: 7rem;
    cursor: pointer;

    .tag {
      margin: 0;
      text-transform: capitalize;
      font-weight: 400;
      color: $brand-gray-medium;

      &.selected {
        font-weight: 700;
        color: $brand-black;
      }
    }

    &:hover {
      .tag {
        font-weight: 700;
        color: $brand-black;
      }
    }
  }

  .tag-icon {
    height: 1.5rem;
    width: 1.5rem;
    background: $brand-black;
    border-radius: 50%;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.3);
    margin-bottom: 0.5rem;
  }
}

.store-grid {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 2rem;
  margin-bottom: 5rem;
  justify-content: center;
}
</style>
